import { defineStore } from 'pinia';

export const useCompetitorStore = defineStore({
    id: 'competitor',
    state() {
        return {
            database: null,
            competitors: [],
            activeCompetitor: {},
        };
    },
    actions: {
        async init() {
            // await this.initDatabase();
            this.initCompetitors();
        },
        async initDatabase() {
            return new Promise((resolve, reject) => {
                let db = window.indexedDB.open("limagrain_db", process.env.VUE_APP_INDEXED_DB_VERSION);

                db.onerror = () => {
                    reject('Error opening the database 2.');
                };

                db.onsuccess = (e) => {
                    this.updateDatabase(e.target.result);
                    resolve('OK');
                };

                // db.onupgradeneeded = (e) => {
                //     if (e.oldVersion === 1) {
                //         e.target.result.deleteObjectStore("competitors");
                //     }

                //     e.target.result.createObjectStore("competitors", { keyPath: "id" });
                // };
            });
        },
        async initCompetitors() {
            await this.initDatabase();
            const competitors = await new Promise((resolve, reject) => {
                this.database.transaction('competitors')
                    .objectStore('competitors')
                    .getAll()
                    .onsuccess = (e) => {
                        resolve(e.target.result);
                    };
            });

            this.updateCompetitors(competitors);
        },
        async getCompetitor(dataId) {
            await this.initDatabase();
            let id = parseInt(dataId);
            if (!this.database) {
                throw new Error('Database not initialized');
            }

            const transaction = this.database.transaction('competitors', 'readwrite');

            const competitorStore = transaction.objectStore('competitors');
            const competitorRequest = competitorStore.get(dataId);

            competitorRequest.onerror = () => {
                console.error('Error find the in the database.');
            };

            competitorRequest.onsuccess = (e) => {
                const findCompetitor = e.target.result;
                if (findCompetitor) {
                    this.updateActiveCompetitor(findCompetitor);
                }
            }
        },
        async addNewCompetitor(data) {
            await this.initDatabase();
            const transaction = this.database.transaction('competitors', 'readwrite');

            const competitorStore = transaction.objectStore('competitors');
            const competitorRequest = competitorStore.get(data.value);

            competitorRequest.onerror = () => {
                console.error('Error find the in the database.');
            };

            competitorRequest.onsuccess = (e) => {
                const findCompetitor = e.target.result;
                if (findCompetitor) {
                    findCompetitor.updated = new Date().getTime();

                    const updateRequest = competitorStore.put(findCompetitor);
    
                    updateRequest.onerror = () => {
                        console.error('Error storing the updated in the database.');
                    };
    
                    updateRequest.onsuccess = () => {
                        const competitors = [...this.competitors];
                        const competitorIndex = competitors.findIndex(n => n.id === findCompetitor.id);
                        competitors[competitorIndex] = findCompetitor;
    
                        this.updateCompetitors(competitors);
                    };
                } else {
                    const now = new Date();
                    const newData = {
                        content: data,
                        created: now.getTime(),
                        updated: now.getTime(),
                        id: data.value
                    };
        
                    const competitors = [newData, ...this.competitors];
                    this.updateCompetitors(competitors);
        
                    this.updateActiveCompetitor(newData);
    
                    transaction.objectStore('competitors').add(newData);
                }
            }
        },

        updateDatabase(database) {
            this.database = database
        },
        updateCompetitors(competitors) {
            this.competitors = competitors
        },
        updateActiveCompetitor(competitor) {
            this.activeCompetitor = competitor
        },
        getCompetitors() {
            return this.competitors;
        }
    },
    getters: {},
});
